import { connectHits } from 'react-instantsearch-dom';

import { windowCheck } from 'utils/helpers';

import ListItem from './list-item';

const Hits = ({ hits }) => {
  // learn about css env variables here: https://www.bram.us/2021/09/13/prevent-items-from-being-hidden-underneath-the-virtual-keyboard-by-means-of-the-virtualkeyboard-api/
  windowCheck && hits.length > 2 && 'virtualKeyboard' in window.navigator;
  // @ts-ignore
  if (windowCheck && hits.length > 2 && 'virtualKeyboard' in window.navigator) window.navigator.virtualKeyboard.overlaysContent = true;

  return (
    <ul className={ `search-hit-list ${hits.length > 5 ? 'fog-machine' : ''}` }>
      {hits.map((hit, index) => (
        <ListItem key={ index } hit={ hit } />
      ))}
      {hits.length > 5 && <div className="fog-machine-bumper" />}
    </ul>
  );
};

const CustomHits = connectHits(Hits);

export default CustomHits;
